// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2D55C","clinicsSelect":"styles_clinicsSelect__2BkOv"};